import React, { Fragment } from "react";
import PageHeader from "./../PageHeader";
import { User } from "../../../models/User/user.model";
import "./restrictedAccess.scss";
import RiskAssessmentPlaceholderImage from "./../../../assets/images/risk-assesment_placeholder.png";
import AuthContainer from "../../../store/container/AuthContainer";
import { AuthState } from "../../../store/reducers/authReducer";
import PendingKycDocuments from "../PendingKycDocuments";
import RejectIcon from "./../../../assets/icons/multi color icons - svg/reject.svg";
import { useHistory } from "react-router-dom";

interface RestrictAccessProps {
  user?: User;
  getUserDetails: Function;
}
function RestrictAccess(props: RestrictAccessProps) {
  const { user, getUserDetails } = props;
  const histroy = useHistory();
  return (
    <div className="restricted-access__container">
      <PageHeader
        title={"Hello, " + (user?.kycBasicInfo?.firstName?.toLowerCase() || "")}
      />
      <p className="restricted-access--text">
        Stay tuned! your account is under verification
      </p>
      {!user?.rejectedDocuments?.length ? (
        <div className="restricted-access__body-pending">
          <img src={RiskAssessmentPlaceholderImage} alt="" />
          <p className="heading">Almost Ready To Invest!</p>
          <p className="review-text">
            Stay tuned! Your account is under verification.
          </p>
          <p className="faq-text" onClick={() => histroy.push("/app/faq")}>
            You may review our FAQ's here.
          </p>
        </div>
      ) : (
        <div className="restricted-access__body-rejected">
          <img src={RiskAssessmentPlaceholderImage} alt="" />
          <p className="rejected-text">
            <img src={RejectIcon} alt="" />
            {!user?.documentUploadSkipped ? "Rejected KYC" : "Missing KYC"}
          </p>
          <p className="text">
            {user?.documentUploadSkipped ? (
              <p>
                Had challenges uploading your documents? Send them to us via{" "}
                <i className="bold">care@vuka.co.ke</i> for assistance.
              </p>
            ) : (
              "Please resubmit your KYC for verification"
            )}
          </p>
          <PendingKycDocuments
            getUserDetails={getUserDetails}
            documents={user?.rejectedDocuments || []}
            isHide={user?.documentUploadSkipped}
          />
        </div>
      )}
    </div>
  );
}

export default RestrictAccess;
